import { Link } from "@reach/router";
import PropTypes from "prop-types";
import React from "react";

const LinkButton = (props) => {
	const { to, children, className } = props;
	return (
		<Link
			to={to}
			className={className || " "}
			getProps={({ isCurrent }) => isCurrent && { className: "active" }}>
			{children}
		</Link>
	);
};

LinkButton.propTypes = {
	to: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	]).isRequired,
	className: PropTypes.string
};

LinkButton.defaultProps = {
	className: ""
};

export default LinkButton;
